"use client"

import { BreadcrumbItem, Breadcrumbs } from "@heroui/breadcrumbs"

/// Workaround for https://github.com/nextui-org/nextui/issues/1403
const BreadcrumbsWorkaround = ({ category }) => (
    <Breadcrumbs className="w-full" color="primary">
        {/* <BreadcrumbItem href="/">Hjem</BreadcrumbItem> */}
        <BreadcrumbItem href="/blog/">Blog</BreadcrumbItem>
        <BreadcrumbItem href={"/blog/?category=" + category.replace(" ", "+")}>{category}</BreadcrumbItem>
    </Breadcrumbs>
)

export default BreadcrumbsWorkaround;